require("!!/Users/vogel/Entwicklung/Workspace/neonis-app-bookings/node_modules/script-loader/addScript.js")(require("!!/Users/vogel/Entwicklung/Workspace/neonis-app-bookings/node_modules/raw-loader/index.js!/Users/vogel/Entwicklung/Workspace/neonis-app-bookings/www/lib/angular-translate/angular-translate.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./www/lib/angular-translate/angular-translate.js
// module id = 477
// module chunks = 0